import apiClient from '../axios.js';

const BASE = '/client/settings';

/**
 * 允許的命名空間，與後端保持一致
 */
export const NAMESPACES = {
  INVENTORY: 'inventory',
  MEMBER_FIELDS: 'member_fields',
  MALL_MEMBER_FIELDS: 'mall_member_fields',
  MEMBER_HOME_STYLE: 'member_home_style',
  REGISTRATION: 'registration',
  MALL_REGISTRATION: 'mall_registration',
  CHATMATE: 'chatmate',
  CHATDESK: 'chatdesk',
  ATTENDANCE: 'attendance',
  POS: 'pos',
  MARKETING: 'marketing',
  LINE: 'line',
  EMAIL: 'email',
  COUPONS: 'coupons',
  AI_CREATIVE: 'ai_creative',
  MEMBER_TIER: 'member_tier',
  WIXTAR: 'wixtar',
};

export const clientSettingsService = {
  getCommerceAccess: () => apiClient.get(`${BASE}/commerce-access`),
  /**
   * 取得所有命名空間的設定
   */
  getAll: () => {
    return apiClient.get(BASE);
  },

  /**
   * 取得指定命名空間的設定（含預設值合併）
   * @param {string} namespace - 'inventory' | 'chatmate' | 'attendance' | 'pos' | 'marketing'
   */
  get: (namespace) => {
    return apiClient.get(`${BASE}/${namespace}`);
  },

  /**
   * 完整覆寫指定命名空間的設定（PUT）
   * @param {string} namespace
   * @param {Object} settings
   */
  set: (namespace, settings) => {
    return apiClient.put(`${BASE}/${namespace}`, settings);
  },

  /**
   * 合併更新指定命名空間的設定（PATCH，只更新傳入的 key）
   * @param {string} namespace
   * @param {Object} patch
   */
  merge: (namespace, patch) => {
    return apiClient.patch(`${BASE}/${namespace}`, patch);
  },

  /**
   * 重置指定命名空間設定回預設值（DELETE）
   * @param {string} namespace
   */
  reset: (namespace) => {
    return apiClient.delete(`${BASE}/${namespace}`);
  },

  /**
   * 將商品規格庫存數量併入指定倉庫，並歸零規格庫存
   * @param {string} warehouseId
   * @param {'add'|'overwrite'} mergeMode - add=累加, overwrite=覆蓋
   */
  migrateToWarehouse: (warehouseId, mergeMode = 'add') => {
    return apiClient.post(`${BASE}/inventory/migrate-to-warehouse`, { warehouseId, mergeMode });
  },

  /**
   * 將所有商品規格庫存歸零
   */
  clearVariantStock: () => {
    return apiClient.post(`${BASE}/inventory/clear-variant-stock`, {});
  },

  /**
   * 將所有倉庫庫存歸零
   */
  clearWarehouseStock: () => {
    return apiClient.post(`${BASE}/inventory/clear-warehouse-stock`, {});
  },

  /**
   * 同步商品規格庫存數量（依進銷存扣減模式）
   * @param {'all_warehouses'|'specific_warehouse'|'store_warehouse'} mode
   * @param {string|null} warehouseId - specific_warehouse 時必傳
   */
  syncInventoryStock: (mode, warehouseId = null) => {
    const body = { mode };
    if (warehouseId) body.warehouseId = warehouseId;
    return apiClient.post(`${BASE}/inventory/sync-stock`, body);
  },

  /**
   * 取得通知收件 Email 清單（billing_contact_email）
   * @returns {{ notificationEmails: string[] }}
   */
  getNotificationEmail: () => {
    return apiClient.get(`${BASE}/notification-email`);
  },

  /**
   * 更新通知收件 Email 清單（最多 5 個，以半形逗號分隔）
   * @param {string} notificationEmails - 逗號分隔的 email 字串
   */
  setNotificationEmail: (notificationEmails) => {
    return apiClient.put(`${BASE}/notification-email`, { notificationEmails: notificationEmails || null });
  },

  getSmsPoints: (params = {}) => apiClient.get(`${BASE}/sms-points`, { params }),

  setSmsThreshold: (threshold) => apiClient.put(`${BASE}/sms-points/threshold`, { threshold }),
};
